import React from "react";
import { Briefcase, Calendar, CheckCircle2, XCircle, TrendingUp, TrendingDown } from "lucide-react";

const TalentKpiGrid = ({ dashboardData }) => {
  const mockKpis = [
    { title: "Total Applications", value: dashboardData?.kpis?.totalApplications || 0, icon: <Briefcase size={18} />, trend: "+12%", isPositive: true },
    { title: "Pending", value: dashboardData?.kpis?.pendingCount || 0, icon: <Calendar size={18} />, trend: "+5%", isPositive: true },
    { title: "Shortlisted", value: dashboardData?.kpis?.shortlistedCount || 0, icon: <CheckCircle2 size={18} />, trend: "+2%", isPositive: true },
    { title: "Rejected", value: dashboardData?.kpis?.rejectedCount || 0, icon: <XCircle size={18} />, trend: "0%", isPositive: false }
  ];

  return (
    <div className="td-kpi-grid">
      {mockKpis.map((kpi, index) => (
        <div className="td-kpi-card" key={index}>
          <div className="kpi-top">
            <div className="kpi-icon-box">{kpi.icon}</div>
            <div className={`kpi-trend ${kpi.isPositive ? 'positive' : 'negative'}`}>
              {kpi.isPositive ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
              <span>{kpi.trend}</span>
            </div>
          </div>
          <h3 className="kpi-value">{kpi.value}</h3>
          <p className="kpi-label">{kpi.title}</p>
        </div>
      ))}
    </div>
  );
};

export default TalentKpiGrid;
